<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['upload', 'delete']);

const { t } = useI18n();

const files = useMapGetter('metaAgent/getFiles');
const uiFlags = useMapGetter('metaAgent/getUIFlags');

const fileInput = ref(null);

const onFileSelected = event => {
  const [file] = event.target.files;
  if (file) emit('upload', file);
  // Reset so re-uploading the same filename still fires a change event.
  event.target.value = '';
};

const remove = file => {
  // eslint-disable-next-line no-alert
  if (!window.confirm(t('META_AGENT.KNOWLEDGE.FILES.DELETE_CONFIRM'))) return;
  emit('delete', file.id);
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-start justify-between gap-4">
      <span class="text-sm text-n-slate-11">
        {{ t('META_AGENT.KNOWLEDGE.FILES.DESCRIPTION') }}
      </span>
      <Button
        :label="t('META_AGENT.KNOWLEDGE.FILES.UPLOAD')"
        size="sm"
        icon="i-lucide-upload"
        :is-loading="uiFlags.savingKnowledge"
        @click="fileInput.click()"
      />
    </div>

    <input
      ref="fileInput"
      type="file"
      class="hidden"
      accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.csv,.xlsx"
      @change="onFileSelected"
    />

    <div
      v-for="file in files"
      :key="file.id"
      class="flex items-center justify-between gap-4 p-4 border rounded-xl bg-n-solid-1 border-n-weak"
    >
      <div class="flex items-center gap-2 min-w-0">
        <span class="i-lucide-file-text size-4 text-n-slate-11" />
        <span class="text-sm truncate text-n-slate-12">
          {{ file.file_name }}
        </span>
      </div>
      <Button
        :label="t('META_AGENT.KNOWLEDGE.FILES.REMOVE')"
        size="xs"
        variant="ghost"
        color="ruby"
        @click="remove(file)"
      />
    </div>

    <span v-if="!files.length" class="text-sm text-n-slate-10">
      {{ t('META_AGENT.KNOWLEDGE.FILES.EMPTY') }}
    </span>
  </div>
</template>
